import { render, staticRenderFns } from "./ApprovalAccountReject.vue?vue&type=template&id=73a4e717&"
import script from "./ApprovalAccountReject.vue?vue&type=script&lang=js&"
export * from "./ApprovalAccountReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports